import { parseResponse } from "../../utils/parseResponse";
import {
  Party,
  RequestedListing,
  Promoter,
  Offer,
  Invitation,
  HostChatMessage,
  PartyModel,
} from "../../types";
import { myPartiesResponseKeys } from "../responseKeys/responseKeys";
import MyPartyApiResponse from "../responses/apiResponses";

export function parseMyPartyResponse(party: MyPartyApiResponse): PartyModel {

  return {
    party: parseResponse<Party>(party?.party, myPartiesResponseKeys.party, ['id']),
    requestedListings: party?.requestedListings?.map((el) =>
      parseResponse<RequestedListing>(
        el,
        myPartiesResponseKeys.requestedListings, 
        ['id']
      )
    ),
    promotersOffers: party.promotersOffers?.map((el) => ({
      promoter: parseResponse<Promoter>(
        el?.promoter,
        myPartiesResponseKeys.promotersOffers.promoter, 
        ['id']
      ),
      offers: el?.offers?.map((offers) =>
        parseResponse<Offer>(
          offers,
          myPartiesResponseKeys.promotersOffers.offers, 
        ['id']
        )
      ),
    })),
    invitations: party?.invitations?.map((el) =>
      parseResponse<Invitation>(el, myPartiesResponseKeys.invitations, [
        'id',
        'firstName',
        'lastName',
      ])
    ),
    hostChatMessages: party?.hostChatMessages?.map((el) =>
      parseResponse<HostChatMessage>(el, myPartiesResponseKeys.hostChatMessages)
    ),
  };
}
